import React from 'react';

/**
 * DataOps Overview Help Content
 */
const OverviewHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Overview Dashboard
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Overview dashboard provides a customizable workspace for monitoring your data pipelines and assets. Create personalized views with the metrics and data that matter most to your team.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Assets</span>: Number of data assets being tracked</p>
          <p>&#8226; <span className="font-medium">Pipeline Runs</span>: Recent pipeline execution count</p>
          <p>&#8226; <span className="font-medium">Success Rate</span>: Percentage of successful runs</p>
          <p>&#8226; <span className="font-medium">Data Events</span>: Recent data platform activities</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Widgets
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Customize your dashboard by managing widgets. Click the <span className="font-semibold">Customize</span> button to enter edit mode.
        </p>

        <div className="space-y-3 text-sm">
          <div>
            <p className="font-medium text-gray-900 dark:text-white mb-1">Adding widgets</p>
            <p className="text-gray-600 dark:text-gray-400">
              Click <span className="font-semibold">Add Widget</span> to browse available metrics and visualizations. Select any widget to add it to your dashboard.
            </p>
          </div>

          <div>
            <p className="font-medium text-gray-900 dark:text-white mb-1">Removing widgets</p>
            <p className="text-gray-600 dark:text-gray-400">
              While in customize mode, click the menu icon (&#8942;) in the top-right corner of any widget and select <span className="font-semibold">Remove</span>.
            </p>
          </div>

          <div>
            <p className="font-medium text-gray-900 dark:text-white mb-1">Rearranging widgets</p>
            <p className="text-gray-600 dark:text-gray-400">
              While in customize mode, drag any widget by its title bar to reposition it. The layout automatically adjusts to fit your screen size.
            </p>
          </div>

          <div>
            <p className="font-medium text-gray-900 dark:text-white mb-1">Resizing widgets</p>
            <p className="text-gray-600 dark:text-gray-400">
              While in customize mode, drag the resize handle (bottom-right corner) of any widget to adjust its dimensions.
            </p>
          </div>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Quick Navigation
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Use the tabs above to explore specific areas: <span className="font-medium">Catalog</span> for data assets, <span className="font-medium">Lineage</span> for data flow visualization, <span className="font-medium">Runs</span> for pipeline monitoring, and more.
        </p>
      </div>

    </>
  );
};

export default OverviewHelp;
